import React from 'react';
import {
  Paper,
  Typography,
  Slider,
  Box,
  TextField,
  MenuItem,
} from '@mui/material';
import { SearchFilters as SearchFiltersType } from '../../types/search.types';

interface SearchFiltersProps {
  filters: SearchFiltersType;
  onChange: (filters: SearchFiltersType) => void;
}

export const SearchFilters: React.FC<SearchFiltersProps> = ({ filters, onChange }) => {
  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant='h6' gutterBottom>
        Search Settings
      </Typography>

      <Box sx={{ mb: 3 }}>
        <Typography variant='body2' color='text.secondary' gutterBottom>
          Similarity Threshold: {filters.threshold.toFixed(2)}
        </Typography>
        <Slider
          value={filters.threshold}
          onChange={(_, value) => onChange({ ...filters, threshold: value as number })}
          min={0.3}
          max={1.0}
          step={0.05}
          marks={[
            { value: 0.3, label: '0.3' },
            { value: 0.5, label: '0.5' },
            { value: 0.7, label: '0.7' },
            { value: 0.9, label: '0.9' },
          ]}
          valueLabelDisplay='auto'
        />
        <Typography variant='caption' color='text.secondary'>
          Higher values return more precise matches
        </Typography>
      </Box>

      <Box>
        <TextField
          select
          fullWidth
          label='Results Limit'
          value={filters.limit}
          onChange={(e) => onChange({ ...filters, limit: Number(e.target.value) })}
        >
          <MenuItem value={5}>5 results</MenuItem>
          <MenuItem value={10}>10 results</MenuItem>
          <MenuItem value={20}>20 results</MenuItem>
          <MenuItem value={50}>50 results</MenuItem>
        </TextField>
      </Box>
    </Paper>
  );
};
